import { useState } from "react";
import { MainCard } from "src/components/main-card-type.tsx";

interface CTAVariant {
  id: 'A' | 'B' | 'C';
  title: string;
  description: string;
  utm: string;
}

const CTA_VARIANTS: CTAVariant[] = [
  {
    id: 'A',
    title: 'Transforme sua simulação em um plano real.',
    description: 'Esse número só vira realidade quando você tem uma estratégia inteligente, constância e bons investimentos. Na AUVP, você aprende a investir para transformar essas simulações em patrimônio de verdade.',
    utm: 'utm_source=calculadora&utm_medium=cta&utm_campaign=juros_compostos&utm_content=variante_a'
  },
  {
    id: 'B',
    title: 'Você viu a simulação. Agora falta o plano.',
    description: 'Cálculo sozinho não constrói patrimônio. Na AUVP, você aprende como sair da teoria e colocar seu plano de investimentos em prática.',
    utm: 'utm_source=calculadora&utm_medium=cta&utm_campaign=juros_compostos&utm_content=variante_b'
  },
  {
    id: 'C',
    title: 'A maioria das pessoas nunca chega nesse número.',
    description: 'Não porque o cálculo está errado, mas porque não têm uma boa estratégia para investir. Na AUVP, você aprende como evitar os erros que fazem as pessoas desistirem no meio do caminho.',
    utm: 'utm_source=calculadora&utm_medium=cta&utm_campaign=juros_compostos&utm_content=variante_c'
  }
];

const BASE_URL = 'https://auvp.com.br';

const getRandomVariant = (): CTAVariant => {
  const randomIndex = Math.floor(Math.random() * CTA_VARIANTS.length);
  return CTA_VARIANTS[randomIndex];
};

export const CTACallToAction = () => {
  const [selectedVariant] = useState<CTAVariant>(() => getRandomVariant());

  const ctaUrl = `${BASE_URL}?${selectedVariant.utm}`;

  return (
    <MainCard className="mt-6">
      <div className="p-6 bg-gradient-to-br from-red-50 to-white rounded-lg border-2 border-primary">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-bold text-primary mb-4">
            {selectedVariant.title}
          </h2>
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6">
            {selectedVariant.description}
          </p>
          <a
            href={ctaUrl}
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-white hover:bg-primary/90 min-h-[50px] w-full sm:w-auto px-8 py-3 text-lg font-semibold"
          >
            Conheça a AUVP
          </a>
        </div>
      </div>
    </MainCard>
  );
};